import '@/assets/css/base.scss';
import 'babel-polyfill';
// 引入神策
// import '@/utils/sensors';
import '@/utils/reporter';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import 'virtual:svg-icons-register';
import SvgIcon from '@/components/svgIcon/index.vue';
import CardWrapper from '@/components/CardWrapper/index.vue';

import { createApp } from 'vue';
import visibility from 'vue-visibility-change';

import App from './App.vue';
import router from './router/index';
import resizeObserver from './utils/resizeObserver';
import { CODEBUG } from 'sfapm'; // 安装哪个依赖，就从哪个依赖引入

// bootstrap引入
// 引入Bootstrap CSS
import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
// // 引入Bootstrap JS（bundle版本）
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'

/* --------------------------------
Vant 中有个别组件是以函数的形式提供的，
包括 Toast，Dialog，Notify 和 ImagePreview 组件。
在使用函数组件时，unplugin-vue-components
无法自动引入对应的样式，因此需要手动引入样式。
------------------------------------- */
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';

import { i18n } from './utils/i18n';

const env = import.meta.env;

if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('sit.') != -1) {
  import('vconsole').then((VConsole) => {
    new VConsole.default();
  });
}

new CODEBUG({
  ENV: 'PROD',
  APPID: '9aa69da9-2cb0-4050-9aed-f54a4741d79b',
  autoTrack: true,
}); // web实例

const app = createApp(App);

app.use(createPinia().use(piniaPluginPersistedstate));

resizeObserver();

function setRem() {
  const html = document.documentElement;
  const width = html.clientWidth;
  const rootValue = html.clientWidth > 750 ? 1140 / 12 : 750 / 28; // 根据设计稿宽度 750px 设置
  html.style.fontSize = `${width / rootValue}px`;
}

// 初始设置
setRem();

// 监听窗口大小变化
window.addEventListener('resize', setRem);

app.use(router);
app.use(visibility);
app.use(i18n);

app.component('SvgIcon', SvgIcon);
app.component('CardWrapper', CardWrapper);
app.mount('#app');
